
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Urbaniahireforoutstation() {



    const cardData =
    {
        keyword: 'Urbania Hire for Outstation in Pune',
        heading: 'Samarth Travels: Urbania Hire for Outstation in Pune',
        headingDescription: 'Samarth Travels offers Urbania hire for outstation in Pune, ideal for long-distance family trips, weekend getaways, corporate tours, and group travel. Our premium Force Urbania vehicles come equipped with air-conditioning, push-back seats, and ample legroom to provide maximum comfort during your outstation journey. With experienced chauffeurs, transparent pricing, and reliable service, Samarth Travels ensures a pleasant and worry-free travel experience.',

        top: 'Top Places to Visit in Pune Outstation with Samarth Travels',

      "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Nestled in the Western Ghats, Mahabaleshwar is a scenic hill station around 120 km from Pune. Known for its lush strawberry farms, panoramic viewpoints like Arthur’s Seat and Wilson Point, and the historic Mahabaleshwar Temple, it offers a cool and refreshing retreat. Boating on Venna Lake and walking through misty trails make it a perfect weekend getaway."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just about 65 km from Pune, the twin hill stations of Lonavala and Khandala are famous for their lush valleys, waterfalls, and forts like Rajmachi and Lohagad. The monsoon season enhances their charm, drawing travelers for trekking, picnics, and chikki shopping. Bhushi Dam and Tiger’s Leap are must-visit attractions in this green paradise."
    },
    {
      "title": "Shirdi",
      "description": "Located approximately 200 km from Pune, Shirdi is a revered pilgrimage town dedicated to Sai Baba. The Sai Baba Temple complex attracts millions of devotees each year. Besides the temple, other spots like Dwarkamai, Chavadi, and the Sai Heritage Village offer spiritual solace and insights into the saint’s life and teachings."
    },
    {
      "title": "Lavasa",
      "description": "Lavasa is a planned hill city about 60 km from Pune, offering Italian-style architecture and lakeside promenades. Popular for romantic getaways and weekend breaks, Lavasa features adventure sports, nature trails, and serene boat rides on the Warasgaon Lake. Its colorful buildings and vibrant cafes make it a photogenic escape."
    },
    {
      "title": "Alibaug",
      "description": "Alibaug is a coastal town around 140 km from Pune, known for its clean beaches and colonial forts. With attractions like Alibaug Beach, Kolaba Fort, and Mandwa Beach, it's a great destination for beach lovers. It’s ideal for water sports, seafood cuisine, and short family trips by road or ferry from Mumbai."
    },
    {
      "title": "Nashik",
      "description": "About 210 km from Pune, Nashik is a blend of spirituality and wine tourism. It’s home to the sacred Godavari River, Trimbakeshwar Temple, and Muktidham, making it a major religious center. Simultaneously, vineyards like Sula and York offer wine tasting and stunning vineyard views, making it a unique dual-experience destination."
    },
    {
      "title": "Kolhapur",
      "description": "Located 230 km from Pune, Kolhapur is rich in heritage, known for the Mahalaxmi Temple, New Palace Museum, and rankala Lake. It’s also famed for its spicy cuisine and handcrafted Kolhapuri chappals. A perfect cultural and culinary escape, Kolhapur provides a deep dive into Maharashtrian traditions."
    },
    {
      "title": "Bhimashankar",
      "description": "Approximately 110 km from Pune, Bhimashankar is a sacred Jyotirlinga shrine nestled in dense forests of the Sahyadri hills. Ideal for spiritual seekers and nature lovers, the region also forms part of a wildlife sanctuary. Trekking trails, misty landscapes, and temple architecture make it a soul-soothing destination."
    },
    {
      "title": "Matheran",
      "description": "Located about 120 km from Pune, Matheran is Asia’s only automobile-free hill station. Famous for its red-soiled paths, vintage toy train, and viewpoints like Panorama Point and Echo Point, it’s a tranquil retreat amidst nature. Horse rides and eco-friendly travel make it a unique experience."
    },
    {
      "title": "Goa",
      "description": "Though around 450 km away, Goa is a top outstation pick from Pune for those seeking beaches, nightlife, and Portuguese charm. From serene South Goa beaches like Palolem to lively North Goa spots like Baga and Anjuna, it’s perfect for parties, watersports, and cultural explorations. The drive or train journey adds to the adventure."
    }
  ],

"services": [
    {
        "name": "Urbania Hire for Outstation in Pune",
        "description": "Samarth Travels provides reliable Urbania hire for outstation trips from Pune. Whether you're planning a weekend getaway or a multi-day road trip, our well-maintained vans ensure a smooth, comfortable ride with spacious interiors and professional drivers who are familiar with long-distance travel."
    },
    {
        "name": "Urbania Rental for Outstation Trips Pune",
        "description": "Travel stress-free with Samarth Travels' Urbania rental services for outstation trips from Pune. Our vehicles are ideal for families, friends, or corporate teams heading to destinations like Lonavala, Mahabaleshwar, Goa, or Mumbai. Enjoy comfort, safety, and flexibility throughout your journey."
    },
    {
        "name": "Rent Urbania for Outstation Travel Pune",
        "description": "Need a vehicle for outstation travel from Pune? Rent a fully-equipped Urbania from Samarth Travels. With air-conditioning, reclining seats, and ample luggage space, our vans are ideal for longer journeys. We provide door-to-door service, punctual pickups, and customizable travel plans for any destination."
    },
    {
        "name": "Urbania Hire for Long-Distance Trips from Pune",
        "description": "Planning a long-distance road trip from Pune? Our Urbania vans are built for endurance and comfort, making them perfect for travel to cities and tourist spots across Maharashtra and beyond. Book with Samarth Travels for experienced drivers, quality service, and stress-free travel."
    },
    {
        "name": "Urbania on Rent for Outstation Tours",
        "description": "Samarth Travels offers Urbania vans on rent for outstation tours from Pune. Whether you're heading to temples, hill stations, or heritage sites, our vans make your journey relaxing and enjoyable. Suitable for family holidays, group trips, and weekend escapes, our service is punctual and affordable."
    },
    {
        "name": "Urbania for Group Trips to Outstation",
        "description": "Coordinate your group travel easily with our Urbania rentals for outstation destinations from Pune. Designed for group tours, college trips, and team outings, our vans provide enough space and comfort to make the road trip part of the fun. Travel together and arrive stress-free!"
    },
    {
        "name": "Rent Urbania for Outstation Sightseeing",
        "description": "Explore top tourist spots near Pune with Samarth Travels’ Urbania rentals. Perfect for sightseeing tours to places like Lavasa, Panchgani, or Alibaug, our vans offer a relaxing way to visit multiple locations in one trip. Customize your itinerary and enjoy smooth travel with experienced drivers."
    },
    {
        "name": "Outstation Urbania Rental Services Pune",
        "description": "Samarth Travels offers comprehensive Urbania rental services for outstation travel from Pune. With 13-seater and 17-seater options available, we cater to various group sizes. Our outstation packages include fuel, driver, tolls, and well-maintained vehicles to make your journey stress-free and enjoyable."
    },
    {
        "name": "Best Urbania Hire for Outstation",
        "description": "Looking for the best Urbania hire service for your outstation travel? Samarth Travels is known for its dependable service, courteous drivers, and clean, comfortable vehicles. Whether it’s a pilgrimage or a beach holiday, choose us for safe, convenient, and affordable travel."
    },
    {
        "name": "Urbania Rental Price for Outstation Trips",
        "description": "Get competitive pricing on Urbania rentals for outstation trips from Pune with Samarth Travels. Our pricing is transparent and includes driver allowance, tolls, and fuel costs. Get a custom quote based on your destination and trip duration, with no hidden charges."
    },
    {
        "name": "Urbania for Outstation Travel with Family",
        "description": "Make family travel more enjoyable with our Urbania vans, ideal for outstation trips from Pune. With child-safe features, cushioned seating, and ample space for luggage, everyone from kids to grandparents can ride comfortably. Perfect for family holidays, reunions, and celebrations outside the city."
    },
    {
        "name": "Urbania for Corporate Outstation Trips",
        "description": "Samarth Travels provides Urbania rentals for corporate outstation travel. Whether it’s a business meeting, offsite training, or team retreat, our vans offer a professional and punctual service. We cater to companies in Pune needing reliable transport for long-distance business trips."
    }
],
"tableData": [
    ["Urbania Hire for Outstation in Pune", "Urbania Rental for Outstation Trips Pune"],
    ["Rent Urbania for Outstation Travel Pune", "Urbania Hire for Long-Distance Trips from Pune"],
    ["Urbania on Rent for Outstation Tours", "Urbania for Group Trips to Outstation"],
    ["Rent Urbania for Outstation Sightseeing", "Outstation Urbania Rental Services Pune"],
    ["Best Urbania Hire for Outstation", "Urbania Rental Price for Outstation Trips"],
    ["Urbania for Outstation Travel with Family", "Urbania for Corporate Outstation Trips"]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Force Urbania Hire for Outstation Travel from Pune",
        "WhyChoosedescription": "We offer reliable and professional Force Urbania van rental services for outstation trips from Pune. Whether you're traveling for business, leisure, or group events, we ensure a smooth, comfortable, and timely journey with experienced drivers and well-maintained vans."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Force Urbania Vans for Long-Distance Travel",
        "WhyChoosedescription": "Our Force Urbania vans are perfect for outstation travel. With seating for 9 to 17 passengers, each van comes with comfortable reclining seats, air-conditioning, ample legroom, and charging ports, ensuring a relaxed and pleasant journey no matter the distance."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers for Outstation Travel",
        "WhyChoosedescription": "Our drivers are highly trained and experienced in handling outstation trips, ensuring your journey is both safe and comfortable. Familiar with various routes, they ensure timely arrivals and smooth navigation, prioritizing your safety and convenience."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Outstation Rentals",
        "WhyChoosedescription": "We offer competitive and transparent pricing with no hidden fees for outstation rentals. Whether you need the Force Urbania for a day or a multi-day trip, we provide flexible and budget-friendly rental packages to suit your travel needs."
    },
    {
        "WhyChooseheading": "24/7 Availability for Flexible Outstation Scheduling",
        "WhyChoosedescription": "Our Force Urbania van rental services are available 24/7, allowing you to plan your outstation trip from Pune at any time. Whether you need an early morning departure or a late-night return, we accommodate your preferred schedule."
    },
    {
        "WhyChooseheading": "Easy Booking and Real-Time Updates for Peace of Mind",
        "WhyChoosedescription": "Booking your Force Urbania rental for an outstation trip is simple and hassle-free through our website or customer support. Once your booking is confirmed, you’ll receive real-time updates, driver contact details, and van arrival information, ensuring a smooth and organized trip."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Force Urbania Vans for Your Safety",
        "WhyChoosedescription": "Our Force Urbania vans are regularly maintained to ensure smooth performance throughout your outstation journey. We also prioritize hygiene by thoroughly cleaning and sanitizing each van before every trip to provide a safe and comfortable environment for all passengers."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Convenient Booking",
        "WhyChoosedescription": "We offer a variety of payment methods, including UPI, credit/debit cards, digital wallets, and cash, so you can complete your booking securely and conveniently."
    }
]























    }

const faqData = [
    {
        id: 1,
        question: 'How do I hire a Force Urbania for an outstation trip from Pune?',
        answer: 'You can easily hire a Force Urbania for your outstation trip by contacting Samarth Travels via our website or phone. Provide details like your destination, travel dates, number of passengers, and any specific requirements, and we’ll arrange the perfect vehicle for your journey.',
    },
    {
        id: 2,
        question: 'What are the rental charges for outstation Urbania hire in Pune?',
        answer: 'For outstation trips, the charges for a Force Urbania typically start at ₹35/km for a 13-seater and ₹36/km for a 17-seater. The charges include the vehicle, driver, and fuel. For specific distances or multi-day trips, customized packages are available.',
    },
    {
        id: 3,
        question: 'Can I hire an Urbania for multiple days for an outstation trip?',
        answer: 'Yes, you can hire a Force Urbania for multi-day outstation trips. We offer flexible rental options with packages tailored to your needs, including accommodation for the driver and other necessities.',
    },
    {
        id: 4,
        question: 'Is the Force Urbania suitable for long outstation journeys?',
        answer: 'Yes, the Force Urbania is ideal for long-distance travel. It comes equipped with recliner seats, air conditioning, ample luggage space, USB charging ports, and personal air vents, making it perfect for outstation journeys.',
    },
    {
        id: 5,
        question: 'Can I customize the pickup and drop-off locations for my outstation trip?',
        answer: 'Absolutely! We offer full flexibility when it comes to pickup and drop-off points. Whether you need a specific location in Pune or need to be dropped off at your destination, we can tailor the plan to your needs.',
    },
    {
        id: 6,
        question: 'Are toll charges and other fees included in the outstation rental?',
        answer: 'Toll charges, parking fees, and any additional permits are not included in the base fare. These are communicated upfront and added to the total cost of your rental for complete transparency.',
    },
    {
        id: 7,
        question: 'Is 24/7 customer support available for outstation Urbania rentals?',
        answer: 'Yes, Samarth Travels provides 24/7 customer support for all outstation bookings. Whether you need assistance before or during your trip, our team is always available to help.',
    },
];

const testimonials = [
    {
        name: 'Mr. Rajeev Kumar',
        role: 'Travel Enthusiast',
        text: 'We rented a 17-seater Urbania for an outstation trip from Pune to Nashik. The van was spacious and comfortable, and the driver was excellent. It was a long journey, but the amenities made the trip enjoyable. I’ll definitely choose Samarth Travels again!',
        image: '/img/testimonial/testi_urbania_rajeeve.jpg',
    },
    {
        name: 'Ms. Neelam Gupta',
        role: 'Tour Operator',
        text: 'I hired a 13-seater Force Urbania for an outstation group trip. The vehicle was well-maintained and came with all modern features. The trip was smooth, and the driver was professional. I highly recommend Samarth Travels for outstation trips.',
        image: '/img/testimonial/testi_urbania_neelam.jpg',
    },
];































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire for Outstation in Pune",
  "image": "https://samarthtravels.com/assets/images/urbania-hire-for-outstation-pune.jpg",
  "description": "Hire a luxury Urbania vehicle for outstation trips from Pune. Available for long-distance journeys, family trips, corporate tours, and group travel. Rent a 14-seater or other Urbania configurations for a comfortable outstation travel experience.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "40000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/urbania-hire-for-outstation-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Urbania Hire for Outstation in Pune | Comfortable & Luxury Bus Hire | Samarth Travels</title>
  <meta 
    name="description" 
    content="Hire a luxury Urbania vehicle for outstation trips from Pune. Available for long-distance journeys, family trips, corporate tours, and group travel. Rent a 14-seater or other Urbania configurations for a comfortable outstation travel experience." 
  />
  <meta 
    name="keywords" 
    content="Urbania hire for outstation in Pune, Urbania rental for outstation trips Pune, Rent Urbania for outstation travel Pune, Urbania hire for long-distance trips from Pune, Urbania on rent for outstation tours, Urbania for group trips to outstation, Rent Urbania for outstation sightseeing, Outstation Urbania rental services Pune, Best Urbania hire for outstation, Urbania rental price for outstation trips, Urbania for outstation travel with family, Urbania for corporate outstation trips" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/47.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniahireforoutstation;